import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext({
  userHash: null,
  token: null,
  isAuthenticated: false,
});

const PARENT_ORIGIN = process.env.REACT_APP_PARENT_ORIGIN || "http://localhost:4200";

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => {
    const isInIframe = window.parent !== window;
    if (isInIframe) {
      return { userHash: null, token: null, isAuthenticated: false };
    }

    return { userHash: null, token: null, isAuthenticated: false };
  });

  useEffect(() => {
    function handleMessage(event) {
      if (event.data?.type === "AUTH_CONTEXT") {
        if (event.origin !== PARENT_ORIGIN) {
          console.warn(`[AuthContext] Origin mismatch: got "${event.origin}", expected "${PARENT_ORIGIN}"`);
          return;
        }

        const { token, userHash } = event.data.payload || {};
        if (userHash) {
          setAuth({
            userHash,
            token: token || null,
            isAuthenticated: true,
          });
        }
      }
    }

    window.addEventListener("message", handleMessage);

    if (window.parent !== window) {
      window.parent.postMessage({ type: "AUTH_READY" }, PARENT_ORIGIN);
    }

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}
